<template>
    <div class="xc-page reset xc-page-sandwich">
        <div class="xc-page-main">
            <div class="xc-breadcrumb">
                <router-link :to="$config.adminPath + '/system/user'">系统设置</router-link>
                <a>场景管理</a>
            </div>
            <div class="xc-row xc-s-flex">
                <div class="xc-card">
                    <div class="xc-card-content">
                        <form
                            class="xc-form"
                            name="search"
                            @submit.prevent="mix_search"
                        >
                         
                            <div class="xc-form-inline">
                                <xc-form-item label="服务名称:">
                                    <input
                                        type="text"
                                        name="scenarioName"
                                        v-model="mix_query.scenarioName"
                                        class="xc-input"
                                        placeholder="请输入服务名称"
                                    >
                                </xc-form-item>
                                <xc-form-item label="服务指令:">
                                    <input
                                        type="text"
                                        name="voiceCommand"
                                        v-model="mix_query.voiceCommand"
                                        class="xc-input"
                                        placeholder="请输入服务指令"
                                    >
                                </xc-form-item>
                                <xc-form-item label="状态:">
                                    <select
                                        class="xc-select"
                                        name="stopStatus"
                                        v-model="mix_query.stopStatus"
                                    >
                                        <option value selected>全部</option>
                                        <option value="0">启用</option>
                                        <option value="1">禁用</option>
                                    </select>
                                </xc-form-item>
                                <div class="xc-btn-group">
                                    <button
                                        type="submit"
                                        class="xc-btn xc-btn-primary"
                                    >查询
                                    </button>
                                    <button
                                        class="xc-btn xc-btn-default"
                                        type="button"
                                        @click="add"
                                    >添加
                                    </button>
                                </div>
                            </div>
                        </form>
                        <table class="xc-table">
                            <thead>
                                <tr>
                                    <th>场景名称</th>
                                    <th>场景编码</th>
                                    <th>语音指令</th>
                                    <th>备注</th>
                                    <th>状态</th>
                                    <th>操作</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="list && list.length">
                                    <tr
                                        v-for="(item,index) in list"
                                        :key="index"
                                    >
                                        <td>{{item.scenarioName}}</td>
                                        <td>{{item.scenarioCode}}</td>
                                        <td>{{item.voiceCommand}}</td>
                                        <td>{{item.scenarioDesc}}</td>
                                        <td>{{item.stopStatus | getStatus}}</td>
                                        <td>
                                            <xc-btn-select
                                                title="管理"
                                            >
                                                <template v-if="groups(item).length">
                                                    <xc-btn-select-item
                                                        v-for="(obj,key) in groups(item)"
                                                        :key="key"
                                                        :title="obj.name"
                                                        @click.native="mix_action(obj,item,$event)"
                                                    ></xc-btn-select-item>
                                                </template>
                                            </xc-btn-select>
                                        </td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr>
                                        <td
                                            colspan="20"
                                            class="xc-s-tac"
                                        >暂无数据
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="xc-page-footer">
            <!-- 分页 -->
            <xc-pagination
                @change="pageChange"
                :page="mix_page"
                :total="mix_total"
                :size="mix_pageSize"
            />
        </div>
        <div class="xc-card">
            <!--添加/编辑-->
            <div
                class="xc-modal xc-modal-dialog"
                v-if="modalName =='add' || modalName =='edit'"
            >
                <div
                    class="xc-modal-mask"
                    @click="modalName=null"
                ></div>
                <div class="xc-modal-wrap xc-anim-scaleIn">
                    <div class="xc-modal-content">
                        <div class="xc-modal-header">
                            <div class="xc-modal-title">{{ modalName =='add'?'添加面板控制':'编辑面板控制' }}</div>
                            <div
                                class="xc-modal-close"
                                @click="modalName=null"
                            ></div>
                        </div>
                        <div class="xc-modal-body" style="max-height: 500px;">
                            <form
                                class="xc-form"
                                name="add"
                                data-vv-scope="add"
                            >
                                <xc-form-item
                                    label="场景名称:"
                                    required
                                >
                                    <input
                                        type="text"
                                        name="scenarioName"
                                        class="xc-input"
                                        v-validate="'required'"
                                        data-vv-as="场景名称"
                                        v-model="fomData.scenarioName"
                                        placeholder="请输入场景名称"
                                        :class="{'xc-input-error':errors.first('scenarioName','add')}"
                                    >
                                    <div class="xc-form-item-error-tips">
                                        {{errors.first("scenarioName","add")}}
                                    </div>
                                </xc-form-item>
                                <xc-form-item
                                    label="场景编码:"
                                    required
                                >
                                    <input
                                        type="text"
                                        name="scenarioCode"
                                        class="xc-input"
                                        v-validate="'required'"
                                        data-vv-as="场景编码"
                                        v-model="fomData.scenarioCode"
                                        placeholder="请输入场景编码"
                                        :class="{'xc-input-error':errors.first('scenarioCode','add')}"
                                    >
                                    <div class="xc-form-item-error-tips">
                                        {{errors.first("scenarioCode","add")}}
                                    </div>
                                </xc-form-item>
                                <xc-form-item
                                    label="服务指令:"
                                    required
                                >
                                    <input
                                        type="text"
                                        name="voiceCommand"
                                        class="xc-input"
                                        v-model="fomData.voiceCommand"
                                        v-validate="'required'"
                                        data-vv-as="服务指令"
                                        placeholder="请输入服务指令"
                                        :class="{'xc-input-error':errors.first('voiceCommand','add')}"
                                    >
                                    <div class="xc-form-item-error-tips">
                                        {{errors.first("voiceCommand","add")}}
                                    </div>
                                </xc-form-item>
                                <xc-form-item
                                    label="房间状态："
                                    required
                                >
                                    <select
                                        name="stopStatus"
                                        class="xc-select"
                                        v-validate="'required'"
                                        data-vv-as="房间状态"
                                        v-model="fomData.stopStatus"
                                    >
                                        <option
                                            value="0"
                                            selected
                                        >启用</option>
                                        <option value="1">禁用</option>
                                    </select>
                                </xc-form-item>
                                <xc-form-item 
                                    label="备注:"
                                >
                                    <textarea
                                        name="scenarioDesc"
                                        v-model="fomData.scenarioDesc"
                                        class="xc-textarea"
                                        placeholder="请输入备注内容"
                                    ></textarea>
                                </xc-form-item>
                            </form>
                        </div>
                        <div class="xc-modal-footer xc-flex-center">
                            <div class="xc-btn-group">
                                <button
                                    type="button"
                                    class="xc-btn xc-btn-default"
                                    @click="modalName=null"
                                >取消
                                </button>
                                <button
                                    type="button"
                                    class="xc-btn xc-btn-primary"
                                    @click="addSubmit"
                                >保存
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--启用/禁用-->
            <div
                class="xc-modal xc-modal-dialog"
                v-if="modalName=='active' || modalName =='disabled'"
            >
                <div
                    class="xc-modal-mask"
                    @click="modalName=null"
                ></div>
                <div class="xc-modal-wrap xc-anim-scaleIn">
                    <div class="xc-modal-content">
                        <div class="xc-modal-header">
                            <div class="xc-modal-title">{{ modalName=='active'?'启用':'禁用' }}</div>
                            <div
                                class="xc-modal-close"
                                @click="modalName = null"
                            ></div>
                        </div>
                        <div class="xc-modal-body xc-flex-center">
                            {{ modalName=='active'?'确定启用该面板控制，启用后将恢复正常？':'确定禁用该面板控制，禁用后该面板不能使用？' }}
                        </div>
                        <div class="xc-modal-footer xc-flex-center">
                            <div class="xc-btn-group">
                                <button
                                    class="xc-btn xc-btn-default"
                                    @click="modalName = null"
                                >取消
                                </button>
                                <button
                                    class="xc-btn xc-btn-primary"
                                    @click="enableSubmit"
                                >确定
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--删除-->
            <div
                class="xc-modal xc-modal-dialog"
                v-if="modalName=='delete'"
            >
                <div
                    class="xc-modal-mask"
                    @click="modalName=null"
                ></div>
                <div class="xc-modal-wrap xc-anim-scaleIn">
                    <div class="xc-modal-content">
                        <div class="xc-modal-header">
                            <div class="xc-modal-title">删除</div>
                            <div
                                class="xc-modal-close"
                                @click="modalName = null"
                            ></div>
                        </div>
                        <div class="xc-modal-body xc-flex-center">
                            确定删除该信息？
                        </div>
                        <div class="xc-modal-footer xc-flex-center">
                            <div class="xc-btn-group">
                                <button
                                    class="xc-btn xc-btn-default"
                                    @click="modalName = null"
                                >取消
                                </button>
                                <button
                                    class="xc-btn xc-btn-primary"
                                    @click="deleteSubmit"
                                >确定
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import listMixin from '../xc-ui/mixins/list';
import "@/libs/font-awesome"
import "@/libs/vee-validate"
import "@/libs/vue-select"
import "@/utils/form-format"
import sceneApi from "@/api/sceneManage"
import myLayerImport from '@/libs/myLayer';

// ip格式化
import "@/utils/ip-format";

myLayerImport();

export default {
    name: 'departmentList',
    mixins: [listMixin],
    data() {
        return {
            deviceGroupIds:"",
            adminPath: this.$config.adminPath,
            // 列表key
            mix_listKey: 'list',

            // 列表唯一字段
            mix_listId: 'id',

            list: [],
            stores: [], //门店列表
            roles: [],   //角色列表
            // 默认查询参数
            mix_query: {
                serviceName: "",
                stopStatus: ""
            },
            group: [
                {
                    name: "编辑",
                    id: 0
                },
                {
                    name: "删除",
                    id: 1
                },
                {
                    name: "启用",
                    id: 2,
                },
                {
                    name: "禁用",
                    id: 3,
                },
                
            ],
            modalName: null,  //弹窗名称,add表示添加\edit表示编辑
            current: null,  //当前表行
            fomData: { 
                stopStatus:0
            },  //表单数据
        }
    },
    filters: {
        getStatus: function (value) {
            if (value == 0) {
                return "启用"
            }
            return "禁用";
        }
    },
    methods: {
        // 初始化数据
        initData() {
            var _this = this;
            // 默认搜索的数据
            const search = {
                pageNum: this.mix_page,
                pageSize: this.mix_pageSize,
                ...this.mix_query,
            }

            //请求列表数据
            sceneApi.getScenarioByPage({params:search}).then(function (ret) {
                _this.list = _this.mix_format(ret.data.list);
                _this.mix_total = ret.data.total;
                _this.mix_page = ret.data.pageNum;
                _this.mix_pageSize = ret.data.pageSize;
            }).catch(function (error) {
                console.log(error)
            });
        },
        // 更新分页
        pageChange: function (page, pageSize) {
            this.mix_page = page;
            this.mix_pageSize = pageSize;
            this.initData();
        },
        // 打开添加弹窗
        add() {
            this.modalName = "add";
            this.fomData = {
                stopStatus:0
            };
        },
        // 操作单条数据
        action(...args) {
            const [action, item] = args;
            this.current = { ...item };
            this.fomData = { ...item };
            switch (action.name) {
                case "编辑":
                    this.modalName = "edit";
                    break;
                case "启用":
                    this.modalName = "active";
                    break;
                case "禁用":
                    this.modalName = "disabled";
                    break;
                case "删除":
                    this.modalName = "delete";
                    break;
                default:
                    break;
            }
        },
        groups: function (item) {
            // var arr = this.group;
            // if (item.stopStatus === 0) {
            //     //0表示启用,1表示禁用
            //     arr[2].name = '禁用';
            // } else {
            //     arr[2].name = '启用';
            // }
            // return arr;
            var arr = this.group.slice(0);
            if (item.stopStatus == 0) {
                //0表示启用,1表示禁用
                arr.splice(2, 1);
            } else {
                arr.splice(3, 1)
            }
            return arr;
        },
        // 添加确定
        addSubmit: function () {
            var myForm = document.add;
            // 验证器命名空间
            const scope = 'add';

            this.$validator.validateAll(scope).then(validate => {
                if (validate) {
                    const data = this.$formFormat(myForm);

                    if(this.modalName === "add"){
                        sceneApi.addScenario(data).then(() => {
                            this.$message.success("添加成功");
                            this.modalName = null;
                            this.initData();
                        })
                    }else{
                        data.scenarioId = this.current.scenarioId;
                        sceneApi.updateScenario(data).then(() => {
                            this.$message.success("修改成功");
                            this.modalName = null;
                            this.initData();
                        })
                    }
                } else {
                    return false;
                }

            })
        },

        //启用、禁用
        enableSubmit: function () {
            var _this = this;
            var currentstatus = 0;
            if(this.modalName=='disabled'){
                currentstatus = 1;
            }
            var obj = {
                scenarioId: this.current.scenarioId,
                stopStatus: currentstatus
            };
            sceneApi.stopStatus(obj).then(function () {
                var statusText = '启用成功';
                if(_this.modalName === 'disabled'){
                    statusText = '禁用成功';
                }
                _this.$message.success(statusText);
                _this.modalName = null;
                _this.initData();
            }).catch(function (error) {
                console.log(error)
            })
        },
        // 删除确认
        deleteSubmit() {
            sceneApi.deleteScenario(this.current.scenarioId).then(v => {
                this.$message.success(v.msg);
                this.modalName = null;
                this.initData()
            })
        }
      
    }
}
</script>

<style  lang="scss">
@import "../xc-ui/scss/variable";
.reset {
    form[name="reset"] {
        .xc-form-item-label {
            width: 80px;
        }
    }
}

</style>

